
















import CompanyUserRequired from "../../CompanyRequired";
import {Component, Prop} from "vue-property-decorator";
import DatePicker from "@/components/DatePicker.vue";
import {DateTime} from "@/modules/models";

@Component({
  components: {
    "at-date-picker": DatePicker,
  }
})
export default class ChooseDateIntervalDialog extends CompanyUserRequired {
  @Prop({default: false})
  value!: boolean;

  get open() {
    return this.value;
  }
  set open(v: boolean) {
    if(v != this.value) {
      this.$emit("input", v);
    }
  }

  readonly initTo = DateTime.now().nextDay().toMidnight();

  from: DateTime | null = null;
  to: DateTime | null = this.initTo;

  ok() {
    const ok1 = this.from != null && this.to != null && this.from.isBefore(this.to);
    if(ok1) {
      if(this.to != null && this.from?.monthOffset(1).isAfter(this.to)) {
        if(this.to?.isAfter(this.initTo)) {
          this.emitSnack(`Tildato frem i tid er ikke noe poeng`, "warning");
        }
        this.$emit("at-date-interval", this.from, this.to);
      } else {
        this.emitSnack(`Maks tillatt datointervall er en måned`, "error");
      }
    } else {
      this.emitSnack(`Fra og til dato må vere utfyllt, med til-dato større enn fra-dato`, "error");
    }
  }
}
